function initTestimonialsSection(root) {
  if (!root || root.dataset.testimonialsInitialized === "true") return;
  root.dataset.testimonialsInitialized = "true";

  var viewport = root.querySelector("[data-testimonials-viewport]");
  var track = root.querySelector("[data-testimonials-track]");
  var prevBtn = root.querySelector("[data-testimonials-prev]");
  var nextBtn = root.querySelector("[data-testimonials-next]");
  if (!viewport || !track) return;

  var slides = Array.prototype.slice.call(track.children);
  if (!slides.length) return;

  var desktopPerView = parseInt(root.dataset.itemsDesktop, 10) || 3;
  var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
  var index = 0;

  function itemsPerView() {
    return window.innerWidth < 768 ? 1 : desktopPerView;
  }

  function maxIndex() {
    return Math.max(0, slides.length - itemsPerView());
  }

  function layout() {
    var perView = itemsPerView();
    var viewportWidth = viewport.getBoundingClientRect().width;
    var slideWidth = (viewportWidth - gap * (perView - 1)) / perView;

    slides.forEach(function (slide) {
      slide.style.width = slideWidth + "px";
    });

    return slideWidth;
  }

  function goTo(slideWidth) {
    var offset = index * (slideWidth + gap);
    track.style.transform = "translateX(-" + offset + "px)";
  }

  function render() {
    var last = maxIndex();
    if (index > last) index = last;

    var slideWidth = layout();
    goTo(slideWidth);

    var canPage = slides.length > itemsPerView();
    if (prevBtn) prevBtn.style.visibility = canPage ? "visible" : "hidden";
    if (nextBtn) nextBtn.style.visibility = canPage ? "visible" : "hidden";
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      index = index <= 0 ? maxIndex() : index - 1;
      goTo(layout());
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      index = index >= maxIndex() ? 0 : index + 1;
      goTo(layout());
    });
  }

  window.addEventListener("resize", render);
  render();
}

function initAllTestimonialsSections(scope) {
  var root = scope || document;
  root.querySelectorAll("[data-testimonials-section]").forEach(initTestimonialsSection);
}

document.addEventListener("DOMContentLoaded", function () {
  initAllTestimonialsSections();
});

// Re-init when a merchant adds/reloads this section in the theme editor.
document.addEventListener("shopify:section:load", function (event) {
  initAllTestimonialsSections(event.target);
});
